import { render, staticRenderFns } from "./ChatGroupHistoryPanel.vue?vue&type=template&id=5385e61c&scoped=true"
import script from "./ChatGroupHistoryPanel.vue?vue&type=script&lang=js"
export * from "./ChatGroupHistoryPanel.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupHistoryPanel.vue?vue&type=style&index=0&id=5385e61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5385e61c",
  null
  
)

export default component.exports